/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Uno_Confirm_Create_ProjectInputs */



/**
* | output |
* | --- |
* | "Create the project “{name}”" |
*
* @param {Uno_Confirm_Create_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_create_project = /** @type {((inputs: Uno_Confirm_Create_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Create_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt „${i?.name}“ erstellen`)
	return /** @type {LocalizedString} */ (`Create the project “${i?.name}”`)
});